﻿// Address
export const RESET_ADDRESS_SUGGESTIONS = state => {
    state.addresslookup.suggestions = [];
};

export const ADDRESS_LOOKUP_FAILURE = state => {
    state.addresslookup.suggestions = [];
    state.addresslookup.failure = true;
};

export const ADDRESS_LOOKUP_SUCCESS = (state, address) => {
    state.addresslookup.suggestions = address;
    state.addresslookup.failure = false;
};

export const STORE_SELECTED_ADDRESS = (state, address) => {
    state.addresslookup.selectedAddress = address;
};

export const RESET_SELECTED_ADDRESS = state => {
    state.addresslookup.selectedAddress = '';
};

export const RESET_ADDRESS_LOOKUP = state => {
    state.addresslookup.failure = false;
    state.products.failure = false;
    state.addresslookup.selectedAddress = '';
    state.products.beginProductSearch = false;
    state.products.isDoneSearching = false;
    state.products.available = [];
    state.addresslookup.suggestions = [];
};

// Products
export const BEGIN_PRODUCT_SEARCH = state => {
    state.products.available = [];
    state.products.beginProductSearch = true;
    state.products.isDoneSearching = false;
    state.products.failure = false;
};

export const STORE_AVAILABLE_PRODUCTS = (state, products, error) => {
    state.products.available = products;
    state.products.isDoneSearching = true;
    if (products.length && products[0].variants.length) {
        state.products.selectedProduct = products[0].code;
        state.installationFeeCode = products[0].installationFeeCode;
        state.activationFeeCode = products[0].activationFeeCode;
        state.paymentFeeCode = products[0].paymentFeeCode;
        state.products.blockId = products[0].blockId;                       
        if( products[0].variants.length > 0)
        {
            state.products.selectedVariant = products[0].variants[0].code;               
            state.products.speedUp = products[0].variants[0].speedUp;
            state.products.speedDown = products[0].variants[0].speedDown; 
            state.products.vendor = products[0].variants[0].vendor; 
        }
    }
};

export const SELECT_VARIANT = (state, parameters) => {
    state.installationFeeCode = parameters.installationFeeCode;
    state.activationFeeCode = parameters.activationFeeCode;
    state.paymentFeeCode = parameters.paymentFeeCode;
    state.products.selectedProduct = parameters.productCode;
    state.products.selectedVariant = parameters.variantCode;
    state.products.speedUp = parameters.speedUp;
    state.products.speedDown = parameters.speedDown;
    state.products.blockId = parameters.blockId;
    state.products.selectedNumberOfVas = parameters.numberOfVas;  
    state.products.vendor = parameters.vendor;
};

export const SELECT_VAS = (state, vas) => {
    state.vas.selectedVas.push(vas);
};

export const DESELECT_VAS = (state, vas) => {
    state.vas.selectedVas.forEach((item, index, object) => {
        if (item.code === vas.code) object.splice(index, 1);
    });
};

export const SET_ADDRESS_QUERY = (state, query) => {
    state.addresslookup.query = query;
};

export const UPDATE_CART_PRICE = (state, parameters) => {
    state.price = parameters.price;
    state.minimumPriceForBindingPeriod = parameters.bindingCost;
};

export const SHOW_VAS_SELECTION_MODAL = (state, bool) => {
    state.vas.showSelectionModal = bool;
};

export const SET_MAX_NUMBER_OF_VAS = (state, int) => {
    state.vas.maxNumberOfVas = int;
    state.products.selectedNumberOfVas = int;
};

export const SHOW_ADDRESS_MISSING_MODAL = (state, bool) => {
    state.alertModals.showAddressMissingModal = bool;
};

export const SET_BLOCK_ID = (state, id) => {
    state.blockId = id;
};

export const SHOW_VAS_LIMIT_MODAL = (state, bool) => {
    state.vas.showLimitModal = bool;
};
